import { PureComponent } from 'react';
import { getHandlingServiceStatusType } from '../../common/flight/flight-colorization';
import { getHandlingServiceInfo } from '../../common/flight/flight-labels';
import Flight from '../../types/flight';
import StatusRow from './status-row';

interface Props {
  selectedFlight: Flight;
}

class HandlingRow extends PureComponent<Props> {
  getDepClassName() {
    const { selectedFlight } = this.props;
    return getHandlingServiceStatusType(
      selectedFlight,
      selectedFlight.departureAirportId
    );
  }
  getArrClassName() {
    const { selectedFlight } = this.props;
    return getHandlingServiceStatusType(
      selectedFlight,
      selectedFlight.arrivalAirportId
    );
  }
  getDepText() {
    const { selectedFlight } = this.props;
    return getHandlingServiceInfo(
      selectedFlight,
      selectedFlight.departureAirportId
    );
  }
  getArrText() {
    const { selectedFlight } = this.props;
    return getHandlingServiceInfo(
      selectedFlight,
      selectedFlight.arrivalAirportId
    );
  }
  render() {
    return (
      <>
        <div className="ft-name">Handling</div>
        <StatusRow
          arrText={this.getArrText()}
          depText={this.getDepText()}
          arrClassName={this.getArrClassName()}
          depClassName={this.getDepClassName()}
        />
      </>
    );
  }
}

export default HandlingRow;
